module.exports = __webpack_public_path__ + "static/media/SCBplus.e495399b.svg";